/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit PlanLength/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import Slider from 'DesignSystem/Slider/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function PlanLength({
  children,
  viewPath = "/App/Account/EmbeddableCoreMessageListener/PaymentsCreatePaymentPlanForExistingInvoice/Content/Content/PlanLength"
  
}) {
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
let newPaymentPlanPlanLengthValueData = fromData.useDataValue({ viewPath,
context: 'new_payment_plan',
path: 'plan_length',
})
let constantData = ' months'
let aggregateData = fromAggregate.join(newPaymentPlanPlanLengthValueData, constantData)
let newPaymentPlanSelectedInstallmentIntervalValueData = fromData.useDataValue({ viewPath,
context: 'new_payment_plan',
path: 'selected_installment_interval',
})
let aggregateData1 = fromHelpers.getStep(newPaymentPlanSelectedInstallmentIntervalValueData)
let planLengthValueData = fromData.useDataValue({ viewPath,
context: 'plan_length',
})
let newPaymentPlanPlanLengthValueData1 = fromData.useDataValue({ viewPath,
context: 'new_payment_plan',
path: 'plan_length',
})
let dtColorsBrandBase = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.brand.base'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let onChange = fromHelpers.useOnChange({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<div
  data-testid="PlanLength.Vertical"
  data-view-path={viewPath}
 style={{'--mt-1-Z2u2SXq': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="PlanLength.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 weight="medium"
 text="Payment Plan Length"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 weight="medium"
 data="new_payment_plan.plan_length"
 data="' months'"
 aggregate="/Data/aggregate.js join"
 text={aggregateData}
/>
</div>
<Slider
  viewPath={`${viewPath}/Slider`}
 backgroundColorThumb={dtColorsBrandBase}
 boxShadowThumb="0px dt.dt.space.xxs dt.space.ls 0px dt.colors.neutral.400"
 heightThumb={dtSpaceS}
 widthThumb={dtSpaceS}
 data="new_payment_plan.selected_installment_interval"
 aggregate="helpers.js getStep"
 min={aggregateData1}
 step={aggregateData1}
 max={60}
 backgroundColor={dtColorsWhite}
 dataType="integer"
 data="plan_length"
 from={planLengthValueData}
 data="new_payment_plan.plan_length"
 value={newPaymentPlanPlanLengthValueData1}
 onChange={onChange}
/>
</div>
{children}
</React.Fragment>)
}